import BirthdaysOfMonth from './BirthdaysOfMonth';

export default BirthdaysOfMonth;
